import "jquery";
import "lodash";
import "timeago";
import "../vendor/kendo.custom.min";
import "./polyfills";
import "./setup/bootstrap";
import "./shim/tcbase";
